<div class="chb" [class.active]="value" (click)="onClick();">
    <div class="chb-input">
        <div class="chb-mark"></div>
    </div>
    <div class="chb-label" [innerHTML]="label"></div>
</div>
